// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1d4ic","upload":"Small_upload__1UqQx","imageWrap":"Small_imageWrap__2qh2f","removeBtn":"Small_removeBtn__31IMg"};